<template>
  <div class="tcm">
    <div ref="scrollContainer" class="tcm__list">
      <div v-if="!items.length" class="tcm__empty">
        <v-icon size="30" color="grey lighten-1">mdi-comment-text-outline</v-icon>
        <span>{{ $t('taskCommentsEmpty') }}</span>
      </div>
      <div
        v-for="(item, index) in items"
        :key="item.id || index"
        class="tcm__item"
        :class="{ 'tcm__item--mine': isMine(item) }"
      >
        <span class="tcm__avatar" :style="{ background: userColor(item.user) }">
          <img v-if="item.user && item.user.avatar" :src="item.user.avatar" alt="">
          <template v-else>{{ initials(item.user) }}</template>
        </span>
        <div class="tcm__bubble">
          <div class="tcm__meta">
            <span class="tcm__name">{{ item.user ? item.user.firstname + ' ' + (item.user.lastname || '') : '' }}</span>
            <span class="tcm__time">{{ item.time }}</span>
            <v-spacer />
            <span v-if="!item.edit" class="tcm__actions">
              <button type="button" :title="$t('edit')" @click="item.edit = true">
                <v-icon x-small>mdi-pencil-outline</v-icon>
              </button>
              <button type="button" class="del" :title="$t('remove')" @click="openRemoveDialog(item)">
                <v-icon x-small>mdi-trash-can-outline</v-icon>
              </button>
            </span>
          </div>
          <template v-if="item.edit">
            <textarea
              v-model="item.content"
              class="tcm__edit"
              rows="2"
              @keydown.enter.exact.prevent="update(item)"
              @keydown.esc="item.edit = false"
            />
            <div class="tcm__edit-actions">
              <v-btn color="primary" depressed x-small height="26" :loading="item.isLoading" @click="update(item)">
                {{ $t('submit') }}
              </v-btn>
              <v-btn text x-small height="26" @click="item.edit = false">{{ $t('cancel') }}</v-btn>
            </div>
          </template>
          <div v-else class="tcm__text">{{ item.content }}</div>
        </div>
      </div>
    </div>

    <div v-if="ref_id" class="tcm__composer">
      <textarea
        ref="input"
        v-model="comment"
        rows="1"
        class="tcm__input"
        :placeholder="$t('create-comment') + ' ...'"
        @input="grow"
        @keydown.enter.exact.prevent="addComment"
      />
      <button type="button" class="tcm__send primary" :disabled="!comment" :title="$t('submit')" @click="addComment">
        <v-icon small>mdi-send</v-icon>
      </button>
    </div>
    <div v-if="ref_id" class="tcm__hint">{{ $t('taskCommentsHint') }}</div>
    <snackbar v-model="snakbar" :text="snakbarText" :active="snakbar" />

    <v-dialog v-model="deletDialog" width="360">
      <div class="tcm-confirm">
        <v-icon size="36" color="pink">mdi-comment-remove-outline</v-icon>
        <p>{{ $t('are-you-sure-delete-comment') }}</p>
        <div class="tcm-confirm__actions">
          <v-btn color="pink" dark depressed @click="remove">{{ $t('remove') }}</v-btn>
          <v-btn text @click="deletDialog = false">{{ $t('cancel') }}</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// Copy of pages/task/comment.vue for the task desk form (original untouched).
// Same endpoints; posts `this.$data` like the original, so no UI-only state in
// data(). Items get edit/isLoading up front so editing is reactive.
import Snackbar from "../../../components/general/snakbar/snakbar";
export default {
  name: "TaskComments",
  components: {
    Snackbar,
  },
  props: ["ref_id", "value"],
  data: () => ({
    snakbar: null,
    snakbarText: null,
    items: [],
    ref: null,
    deleteItem: null,
    deletDialog: false,
    edit: null,
    comment: null,
  }),
  watch: {
    ref_id() {
      this.items = [];
      this.comment = null;
      this.getComment();
    },
    value() {
      this.items = [];
      this.comment = null;
      this.getComment();
    },
  },
  // The form may mount with the task id already set, so the ref_id watcher
  // never fires; load the existing comments up front.
  mounted() {
    this.getComment();
  },
  methods: {
    openRemoveDialog(item) {
      this.deletDialog = true;
      this.deleteItem = item;
    },
    remove() {
      var app = this;
      this.deletDialog = false;
      app.$axios
        .delete(this.$endpoint + "taskcomment/" + app.deleteItem.id)
        .then((res) => {
          var index = this.items.findIndex((x) => x.id === app.deleteItem.id);
          app.items.splice(index, 1);
          app.$emit("count", app.items.length);
          app.deleteItem = null;
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => {});
    },
    update(item) {
      var app = this;
      app.ref = app.ref_id;
      item.isLoading = true;
      app.$axios
        .put(this.$endpoint + "taskcomment/" + item.id, { comment: item.content })
        .then((res) => {})
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => {
          item.isLoading = false;
          item.edit = false;
        });
    },
    getComment() {
      var app = this;
      if (!this.ref_id) return false;
      app.$axios
        .get(this.$endpoint + "taskcomment/show", {
          params: {
            refId: this.ref_id,
          },
        })
        .then((res) => {
          app.items = (res.data.data || []).map((c) => ({ edit: false, isLoading: false, ...c }));
          app.$emit("count", app.items.length);
          app.scrollToBottom(app);
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    scrollToBottom(app) {
      setTimeout(function () {
        var el = app.$refs.scrollContainer;
        if (el) el.scrollTop = el.scrollHeight;
      }, 50);
    },
    grow(e) {
      var el = e.target;
      el.style.height = "auto";
      el.style.height = Math.min(el.scrollHeight, 140) + "px";
    },
    initials(user) {
      if (!user) return "?";
      return ((user.firstname || "").charAt(0) + (user.lastname || "").charAt(0)) || "?";
    },
    // Stable colour per user for avatars without a picture.
    userColor(user) {
      var palette = ["#5c6bc0", "#26a69a", "#ef6c00", "#8e24aa", "#00897b", "#3949ab", "#d81b60", "#6d4c41"];
      var key = String((user && (user.id || user.firstname)) || "");
      var n = 0;
      for (var i = 0; i < key.length; i++) n += key.charCodeAt(i);
      return (user && user.color) || palette[n % palette.length];
    },
    isMine(item) {
      var me = this.$store.state.user || {};
      return !!(item.user && me.id && item.user.id === me.id);
    },
    addComment() {
      var app = this;
      if (!this.ref_id) {
        this.snakbarText = app.$t("alert-task-register-at-first");
        this.snakbar = true;
      }
      if (!this.comment || !String(this.comment).trim()) return false;
      app.ref = app.ref_id;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "taskcomment", this.$data)
        .then((res) => {
          app.items.push({ edit: false, isLoading: false, ...res.data.data });
          app.$emit("count", app.items.length);
          app.comment = null;
          if (app.$refs.input) app.$refs.input.style.height = "auto";
          app.scrollToBottom(app);
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
  },
};
</script>

<style scoped>
.tcm {
  display: flex;
  flex-direction: column;
  border: 1px solid #e8ebf0;
  border-radius: 6px;
  background: #fafbfc;
  overflow: hidden;
}
.theme--dark .tcm {
  background: #191919;
  border-color: #333;
}
/* Fixed comfortable height: several messages visible, scrolls inside. */
.tcm__list {
  height: 300px;
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.tcm__empty {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 18px 0;
  font-size: 0.8rem;
  color: #9aa4b2;
}
.tcm__item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.tcm__avatar {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
}
.tcm__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tcm__bubble {
  flex: 1 1 auto;
  min-width: 0;
  background: #fff;
  border: 1px solid #e8ebf0;
  border-radius: 6px;
  border-start-start-radius: 2px;
  padding: 8px 12px 10px;
}
.theme--dark .tcm__bubble {
  background: #1e1e1e;
  border-color: #333;
}
.tcm__item--mine .tcm__bubble {
  background: #eef5ff;
  border-color: #d6e6ff;
}
.theme--dark .tcm__item--mine .tcm__bubble {
  background: #1b2a40;
  border-color: #27416a;
}
.tcm__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 22px;
}
.tcm__name {
  font-size: 0.78rem;
  font-weight: 700;
}
.tcm__time {
  font-size: 0.7rem;
  color: #9aa4b2;
}
.tcm__actions {
  display: inline-flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s;
}
.tcm__item:hover .tcm__actions,
.tcm__item:focus-within .tcm__actions {
  opacity: 1;
}
@media (hover: none) {
  .tcm__actions {
    opacity: 1;
  }
}
.tcm__actions button {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tcm__actions button:hover {
  background: rgba(0, 0, 0, 0.06);
}
.tcm__actions .v-icon {
  color: #6b7280;
}
.tcm__actions .del .v-icon {
  color: #d81b60;
}
.tcm__text {
  margin-top: 2px;
  font-size: 0.84rem;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
.tcm__edit {
  width: 100%;
  margin-top: 4px;
  padding: 6px 8px;
  border: 1px solid var(--v-primary-base);
  border-radius: 6px;
  outline: none;
  resize: vertical;
  font-size: 0.84rem;
  background: #fff;
  color: inherit;
}
.theme--dark .tcm__edit {
  background: #121212;
}
.tcm__edit-actions {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}
.tcm__composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 10px 12px 4px;
  border-top: 1px solid #e8ebf0;
  background: #fff;
}
.theme--dark .tcm__composer {
  background: #1e1e1e;
  border-color: #333;
}
.tcm__input {
  flex: 1 1 auto;
  min-height: 38px;
  max-height: 140px;
  padding: 8px 12px;
  border: 1px solid #dfe3ea;
  border-radius: 6px;
  outline: none;
  resize: none;
  font-size: 0.85rem;
  line-height: 1.5;
  background: #f8f9fb;
  color: inherit;
  transition: border-color 0.15s, background 0.15s;
}
.tcm__input:focus {
  border-color: var(--v-primary-base);
  background: #fff;
}
.theme--dark .tcm__input {
  background: #121212;
  border-color: #3a3a3a;
}
.tcm__send {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 6px;
  background-color: #0066ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tcm__send .v-icon {
  color: #fff !important;
}
.v-application--is-rtl .tcm__send .v-icon {
  transform: scaleX(-1);
}
.tcm__send:disabled {
  opacity: 0.45;
  cursor: default;
}
.tcm__hint {
  font-size: 0.68rem;
  color: #9aa4b2;
  padding: 2px 12px 8px;
  background: #fff;
}
.theme--dark .tcm__hint {
  background: #1e1e1e;
}
.tcm-confirm {
  background: #fff;
  border-radius: 6px;
  padding: 22px 18px 14px;
  text-align: center;
}
.theme--dark .tcm-confirm {
  background: #1e1e1e;
}
.tcm-confirm p {
  margin: 10px 0 0;
  font-weight: 600;
}
.tcm-confirm__actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
</style>
